/**
 * @function convertContact
 * @param {ContactInfo} contact
 * @param {Company[]} companies
 * @param {Language} languageTypes
 * @returns {ContactInfo}
 */
function convertContact(contact, companies, languageTypes) {
	let newObj = {};
	let addressWork = {
		address_id: '',
		type: '4',
		street: '',
		city: '',
		province: '',
		country: '',
		postalCode: '',
		placeId: '',
		coordinate: { lat: '', lng: '' },
		unit: '',
		fullAddress: '',
	};

	let addressHome = {
		address_id: '',
		type: '5',
		street: '',
		city: '',
		province: '',
		country: '',
		postalCode: '',
		placeId: '',
		coordinate: { lat: '', lng: '' },
		unit: '',
		fullAddress: '',
	};

	let addressOther = {
		address_id: '',
		type: '6',
		street: '',
		city: '',
		province: '',
		country: '',
		postalCode: '',
		placeId: '',
		coordinate: { lat: '', lng: '' },
		unit: '',
		fullAddress: '',
	};

	let languageArr = [];

	const companyArr = (companies || []).filter((company) => (contact.Customers || []).includes(company.Id));
	// const typeArr = contactTypes.filter((type) => contact.ContactTypes.includes(type.Id));

	if (contact.LanguageIds?.length > 0) {
		languageArr = (languageTypes || []).filter((type) => contact.LanguageIds.includes(type.id));
	}

	if (!contact?.AddressIds || contact.AddressIds.length === 0) {
		newObj = {
			id: contact.Id,
			canEdit: contact.CanEdit,
			contactOf: contact.ContactOf,
			isEmployee: contact.IsEmployee,
			firstName: contact?.FirstName,
			lastName: contact?.LastName,
			companies: companyArr,
			image: { file: '', name: '', preview: contact?.Image, id: contact?.VFileId },
			emailWork: contact?.WorkEmail,
			emailPersonal: contact?.PersonalEmail,
			emailOther: contact?.OtherEmail,
			// contactTypes: typeArr,
			contactPosition: contact?.ContactPosition,
			phoneWork: {
				number: contact?.WorkPhone,
				dialCode: contact?.WorkPhoneDialCode,
				countryCode: contact?.WorkphoneCountryCode,
				ext: contact?.WorkPhoneExt,
			},
			phoneMobile: {
				number: contact?.CellPhone,
				dialCode: contact?.CellPhoneDialCode,
				countryCode: contact?.CellPhoneCountryCode,
				ext: contact?.CellPhoneExt,
			},
			phoneOther: {
				number: contact?.HomePhone,
				dialCode: contact?.HomePhoneDialCode,
				countryCode: contact?.HomePhoneCountryCode,
				ext: contact?.HomePhoneExt,
			},
			note: contact?.Note,
			addressWork: addressWork,
			addressHome: addressHome,
			addressOther: addressOther,
			languages: languageArr.length > 0 ? languageArr : [],
			vFileId: contact?.VFileId,
		};
	} else {
		let tempObj = null;

		for (let i = 0; i < contact.AddressIds?.length; i++) {
			for (let j = 0; j < contact.Addresses?.length; j++) {
				if (contact.AddressIds[i].address_id === contact.Addresses[j].address_id) {
					const streetArr = (contact.Addresses[j].line1 || '').split(',');

					tempObj = {
						address_id: contact.Addresses[j].address_id,
						type: contact.AddressIds[i].address_type_id,
						street: streetArr[0],
						city: contact.Addresses[j].city,
						province: contact.Addresses[j].province,
						country: contact.Addresses[j].country,
						postalCode: contact.Addresses[j].postalCode,
						placeId: contact.Addresses[j].placeId,
						coordinate: { lat: contact.Addresses[j].lat, lng: contact.Addresses[j].lng },
						unit: streetArr[1],
						fullAddress:
							contact.Addresses[j].line1 +
							' ' +
							contact.Addresses[j].city +
							' ' +
							contact.Addresses[j].country +
							' ' +
							contact.Addresses[j].postal_code,
					};

					if (tempObj.type === '4') {
						addressWork = tempObj;
					} else if (tempObj.type === '5') {
						addressHome = tempObj;
					} else if (tempObj.type === '6') {
						addressOther = tempObj;
					}
				}
			}
		}

		newObj = {
			id: contact.Id,
			canEdit: contact.CanEdit,
			contactOf: contact.ContactOf,
			isEmployee: contact.IsEmployee,
			firstName: contact?.FirstName,
			lastName: contact?.LastName,
			companies: companyArr,
			image: { file: '', name: '', preview: contact?.Image, id: contact?.VFileId },
			emailWork: contact?.WorkEmail,
			emailPersonal: contact?.PersonalEmail,
			emailOther: contact?.OtherEmail,
			// contactTypes: typeArr,
			contactPosition: contact?.ContactPosition,
			phoneWork: {
				number: contact?.WorkPhone,
				dialCode: contact?.WorkPhoneDialCode,
				countryCode: contact?.WorkphoneCountryCode,
				ext: contact?.WorkPhoneExt,
			},
			phoneMobile: {
				number: contact?.CellPhone,
				dialCode: contact?.CellPhoneDialCode,
				countryCode: contact?.CellPhoneCountryCode,
				ext: contact?.CellPhoneExt,
			},
			phoneOther: {
				number: contact?.HomePhone,
				dialCode: contact?.HomePhoneDialCode,
				countryCode: contact?.HomePhoneCountryCode,
				ext: contact?.HomePhoneExt,
			},
			note: contact?.Note,
			addressWork: addressWork,
			addressHome: addressHome,
			addressOther: addressOther,
			languages: languageArr.length > 0 ? languageArr : [],
			vFileId: contact?.VFileId,
		};
	}
	return newObj;
}

export default convertContact;
